import { useContext } from 'react';
import { IPolygonV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

import { useDirectMarkerUpdates } from 'components/minute/builders/v2/useDirectMarkerUpdates';
import { SelectedMarkerV2Common } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Common';
import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';
import { ICoordinates } from 'libs/types/map/mapTypes';
import polylabel from 'polylabel';

interface Props {
    markerId: string;
}

export const SelectedMarkerV2Polygon = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);
    const directMarkerUpdates = useDirectMarkerUpdates();

    const marker = ctxEdit.worldMarkers.find(
        (e) => e.id === props.markerId
    ) as IPolygonV2WorldMarker;

    const updateMarkerDirectly = (newCoordinates: ICoordinates[]) => {
        directMarkerUpdates.updatePolygon(marker.id, newCoordinates, 'regular', {
            closePolygon: true
        });
    };

    const updateMarkerGlobally = (newCoordinates: ICoordinates[]) => {
        const [lat, lng] = polylabel([newCoordinates.map(({ lat, lng }) => [lat, lng])]);
        ctxEdit.updateWorldMarker(props.markerId, { lat, lng }, { coordinates: newCoordinates });
    };

    return (
        <SelectedMarkerV2Common
            markerId={marker.id}
            coordinates={marker.elementData.coordinates}
            minCoordinatesCount={3}
            isClosedPolygon={true}
            updateMarkerDirectly={updateMarkerDirectly}
            updateMarkerGlobally={updateMarkerGlobally}
            color={marker.elementData.fill.color}
        />
    );
};
